import { WorkplaceDefaultFields } from "../../../api/graphql/workplaces";

// deivce can be assigned to room and wayFinder, in order to display it we have created this helper
export const getDeviceAssignedName = (
  room?: WorkplaceDefaultFields
): "room" | "wayFinder" => (room !== null ? "room" : "wayFinder");
